import { SignIn, SignUp } from '@clerk/clerk-react';
import { useState } from 'react';
import { X } from 'lucide-react';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const clerkAppearance = {
  elements: {
    rootBox: 'w-full',
    card: 'shadow-none border-0 p-0 bg-transparent',
    headerTitle: 'text-2xl font-extrabold text-gray-900',
    headerSubtitle: 'text-gray-500',
    socialButtonsBlockButton: 'border border-gray-200 hover:bg-gray-50',
    formButtonPrimary:
      'bg-gradient-to-r from-rose-500 to-amber-500 hover:from-rose-400 hover:to-amber-400 text-white font-bold rounded-full py-3 transition-all duration-200',
    footerActionLink: 'text-indigo-600 hover:text-indigo-700 font-semibold',
    formFieldInput:
      'rounded-lg border-gray-300 focus:ring-2 focus:ring-indigo-500 focus:border-transparent',
    identityPreviewEditButton: 'text-indigo-600',
  },
};

export function AuthModal({ isOpen, onClose }: AuthModalProps) {
  const [mode, setMode] = useState<'sign-in' | 'sign-up'>('sign-up');

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/60 z-[100] flex items-end sm:items-center justify-center p-0 sm:p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="bg-white w-full sm:max-w-md sm:rounded-2xl rounded-t-2xl max-h-[92vh] overflow-y-auto">
        {/* Close button */}
        <div className="flex items-center justify-end p-3 border-b border-gray-100">
          <button
            onClick={onClose}
            className="p-2 rounded-full text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Mode toggle tabs */}
        <div className="flex border-b border-gray-100">
          <button
            onClick={() => setMode('sign-up')}
            className={`flex-1 py-4 text-sm font-semibold transition-colors ${
              mode === 'sign-up'
                ? 'text-indigo-600 border-b-2 border-indigo-600'
                : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            Create account
          </button>
          <button
            onClick={() => setMode('sign-in')}
            className={`flex-1 py-4 text-sm font-semibold transition-colors ${
              mode === 'sign-in'
                ? 'text-indigo-600 border-b-2 border-indigo-600'
                : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            Sign in
          </button>
        </div>

        {/* Clerk component */}
        <div className="p-4 sm:p-6">
          {mode === 'sign-up' ? (
            <SignUp
              appearance={clerkAppearance}
              afterSignUpUrl="/investor"
            />
          ) : (
            <SignIn
              appearance={clerkAppearance}
              afterSignInUrl="/investor"
            />
          )}
        </div>
      </div>
    </div>
  );
}
